import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstatePropStats } from 'redux/realEstateSlice';
import MarketShare from './MarketShare';
import PropTypes from 'prop-types';

const WidgetStats = ({ title, cardClasses }) => {
  // * States
  const dispatch = useDispatch();
  const { realEstate, realEstatePropStats } = useSelector(
    state => state.realEstate
  );

  const { loadingActions } = useSelector(state => state.props);

  const [data, setData] = useState();

  useEffect(() => {
    realEstate?.id && dispatch(getRealEstatePropStats(realEstate.id));
  }, [realEstate]);
  useEffect(() => {
    realEstate?.id && dispatch(getRealEstatePropStats(realEstate.id));
  }, [loadingActions]);
  useEffect(() => {
    realEstatePropStats &&
      setData([
        {
          id: 1,
          value: realEstatePropStats.published,
          name: 'Publicadas',
          color: 'success'
        },
        {
          id: 2,
          value: realEstatePropStats.pending,
          name: 'Pendientes',
          color: 'primary'
        },
        {
          id: 3,
          value: realEstatePropStats.paused,
          name: 'Pausadas',
          color: 'warning'
        }
      ]);
  }, [realEstatePropStats]);

  return (
    <>
      {data && (
        <MarketShare
          data={data}
          now={
            realEstatePropStats?.published +
            realEstatePropStats?.pending +
            realEstatePropStats?.paused
          }
          radius={['100%', '80%']}
          cardClasses={cardClasses}
          title={title}
        />
      )}
    </>
  );
};

WidgetStats.propTypes = {
  cardClasses: PropTypes.string,
  title: PropTypes.string
};

export default WidgetStats;
